import { Colors } from "./Colors"

const tags = {
    // bold: {
    //     fontFamily: Fonts.InterBold,
    // },
    bullet: {
        wrap: {
            mode: 'word',
            width: 700
        },
        x: 20

    },
    butterfly: {
        fontFamily: "DKButterfly",
    },
    size24:{
        fontSize: "24px",
    },
    boldCentury: {
        fontFamily: "CenturyGothicBold",
    },
    boldCenturyBlue: {
        fontFamily: "CenturyGothicBold",
        color: Colors.Text.TextBlue
    },
    boldCenturyRed: {
        fontFamily: "CenturyGothicBold",
        color: Colors.Text.TextOrange
    },
    centuryBlue: {
        fontFamily: "CenturyGothic",
        color: Colors.Text.TextBlue
    }
}

export {
    tags
}